export const apiPath = '/v2/badges';
const actionType = 'BADGE_CONTROL';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
